import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { Classifier } from '../models/Classifier';
import { NotificationService } from '../../core/services/notification.service';

@Injectable()
export class ClassifiersService extends DataService<Classifier> {

	constructor(http: HttpClient, notificationService: NotificationService) {
		super(http, notificationService);
		this.controllerName = "classifiers";
	}

}